import { render, staticRenderFns } from "./AddToPurchaseListButton.vue?vue&type=template&id=208f92d2&scoped=true"
import script from "./AddToPurchaseListButton.vue?vue&type=script&lang=ts"
export * from "./AddToPurchaseListButton.vue?vue&type=script&lang=ts"
import style0 from "./AddToPurchaseListButton.vue?vue&type=style&index=0&id=208f92d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208f92d2",
  null
  
)

export default component.exports